import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from '../../services/api/axiosBaseQuery';
import { ApiResponse } from '../../services/httpService';
import { Task } from '../../models/task';
import { EmployeesApiUrl } from '../../services/api/employeeServices';

export interface GetEmployeeTasksParams {
  internalId: string;
  projectId?: string;
  skip?: number;
  take?: number;
  filter?: string;
  includeDeleted?: boolean;
}

export const tasksService = createApi({
  reducerPath: 'tasksService',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['Tasks'],
  endpoints: (builder) => ({
    getEmployeeTasks: builder.query<ApiResponse<Task>, GetEmployeeTasksParams>({
      query: ({ internalId, ...params }) => ({
        url: `${EmployeesApiUrl}/${internalId}/Tasks`,
        params,
      }),
      providesTags: ['Tasks'],
      keepUnusedDataFor: 30,
    }),
  }),
});

export const { useGetEmployeeTasksQuery } = tasksService;
